import { IChange } from "./IChange";
import { Key } from "./Key";
import { BettingOffer } from "./BettingOffer";

export class BettingOfferKeyUpdate {
    bettingTypeId: string;
    key?: Key;
    keyId: string;
    offers?: IChange<BettingOffer, BettingOffer>;
}